import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* global $ */

import React from "react";
import "./BroadsideTool.scss";
import "./BroadsideToolCms.scss";
import store from "@/store/store";
import BroadsideContactList from "./BroadsideContactList";
import { openContact, startChatWith } from "@/store/chat/contacts/Actions";
import { sortedContactsSelector, totalUnreadMessageCountSelector } from "@/store/chat/contacts/Selectors";
import BroadsideNotification from "./BroadsideNotification";
import { currentCmsCompanyId, QRCODE_PATH, isKnownPage } from "../../common/fhtGlobalEnv";
import BroadsideContactListCms from "./BroadsideContactListCms";
import { dispatchThunk } from "@/store/dispatchThunk";
import { KnownPageTypeEnum } from "@/apis/model/KnownPageTypeEnum";
import { describeFhtConstantsEnum } from "@/apis/model/describeFhtConstantsEnum";
import { FhtConstantsEnum } from "@/apis/model/FhtConstantsEnum";
import { LanguageSettingEnum } from "./broadsideToolUtil";
import { CompanyApiApi } from "@/apis/api/CompanyApiApi";
import { qqKeFuHref } from "../utils";
var ScrollTopThreshold = 100;
var isInCms = Boolean(currentCmsCompanyId);
var langSetting = LanguageSettingEnum.Chinese;
var companyApiApi = new CompanyApiApi();
var isProductDetail = isKnownPage(KnownPageTypeEnum.ProductDetail);

var BroadsideTool =
/** @class */
function (_super) {
  __extends(BroadsideTool, _super);

  function BroadsideTool(props) {
    var _this = _super.call(this, props) || this;

    _this.getOwnState = function () {
      var state = store.getState();
      var scrollTop = $(document).scrollTop();
      return {
        showGoTop: scrollTop > ScrollTopThreshold,
        contacts: sortedContactsSelector(state),
        totalUnreadMessageCount: totalUnreadMessageCountSelector(state),
        QQ: []
      };
    };

    _this.onStoreChange = function () {
      _this.setState(_this.getOwnState());
    };

    _this.onScroll = function () {
      var scrollTop = $(document).scrollTop();
      var showGoTop = scrollTop > ScrollTopThreshold;

      if (_this.state.showGoTop !== showGoTop) {
        _this.setState({
          showGoTop: showGoTop
        });
      }
    };

    _this.handleOpenContact = function (contact) {
      store.dispatch(openContact(contact));
    };

    _this.handleOpenCustomerService = function (user) {
      dispatchThunk(store, startChatWith(user.ClientId));
    };

    _this.scrollToTop = function (e) {
      $("html, body").animate({
        scrollTop: 0
      }, "slow");
      e.preventDefault();
      e.stopPropagation();
    };

    _this.state = _this.getOwnState();
    return _this;
  }

  BroadsideTool.prototype.setOtherLang = function () {
    langSetting = LanguageSettingEnum.English;
  };

  BroadsideTool.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var $techSupport, currCompanyId, companydetail;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.unsubscribe = store.subscribe(this.onStoreChange);
            $(document).on("scroll.broadsidetool.fht360", this.onScroll);
            $techSupport = $(".cms-footer__tech-support");

            if ($techSupport && $techSupport.text().toLowerCase().includes("technical support")) {
              console.log("is for en");
              this.setOtherLang();
            }

            if (!(isInCms || isProductDetail)) return [3
            /*break*/
            , 2];
            currCompanyId = isInCms ? currentCmsCompanyId : jQuery("#FhtWebGlobal_CompanyId").val();
            console.log(currCompanyId);
            return [4
            /*yield*/
            , companyApiApi.companyApiGetCompany({
              companyId: currCompanyId
            })];

          case 1:
            companydetail = _a.sent();
            this.setState({
              QQ: companydetail != undefined ? companydetail.CompanyContactInfo.QQ : []
            });
            _a.label = 2;

          case 2:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BroadsideTool.prototype.componentWillUnmount = function () {
    this.unsubscribe && this.unsubscribe();
    $(document).off("scroll.broadsidetool.fht360", this.onScroll);
  };

  BroadsideTool.prototype.render = function () {
    var isChinese = langSetting === LanguageSettingEnum.Chinese;
    var pathname = window.location.pathname;
    console.log("pathname:", pathname);
    var isHome = pathname === "" || pathname === "/";
    console.log("isHome:", isHome);
    return _jsxs("ul", __assign({
      className: !isInCms ? "broadside-tool" : "broadside-tool--cms"
    }, {
      children: [_jsx("li", __assign({
        className: "broadside-tool__item broadside-tool__top " + (this.state.showGoTop ? "" : "broadside-tool__top-hide"),
        onClick: this.scrollToTop
      }, {
        children: _jsx("div", __assign({
          className: "broadside-tool__item-content"
        }, {
          children: _jsx("a", {
            rel: "nofollow"
          }, void 0)
        }), void 0)
      }), void 0), !isInCms && isHome && _jsxs("li", __assign({
        className: "broadside-tool__item broadside-tool__tel"
      }, {
        children: [_jsx("span", {
          className: "icon broadside-tool__tel-icon"
        }, void 0), _jsx("div", __assign({
          className: "broadside-tool__item-content"
        }, {
          children: _jsxs("div", __assign({
            className: "broadside-tool__tel-detail"
          }, {
            children: [_jsxs("div", __assign({
              className: "broadside-tool__tel-numbers"
            }, {
              children: [_jsx("h5", __assign({
                className: "broadside-tool__tel-numbers-title"
              }, {
                children: "\u70FD\u706B\u53F0\u5BA2\u670D"
              }), void 0), _jsxs("div", __assign({
                className: "broadside-tool__tel-numbers-val"
              }, {
                children: [_jsx("span", {
                  children: "\u7535\u8BDD\uFF1A"
                }, void 0), _jsxs("span", {
                  children: ["0519-68206653 ", _jsx("br", {}, void 0), _jsx("br", {}, void 0), describeFhtConstantsEnum(FhtConstantsEnum.CzCustmerServiceHotline)]
                }, void 0)]
              }), void 0)]
            }), void 0), _jsx("span", {
              className: "broadside-tool__arrow broadside-tool__tel-arrow"
            }, void 0)]
          }), void 0)
        }), void 0)]
      }), void 0), (isInCms || isProductDetail) && _jsxs("li", __assign({
        className: "broadside-tool__item broadside-tool__qq"
      }, {
        children: [_jsx("span", {
          className: "icon broadside-tool__qq-icon"
        }, void 0), _jsx("span", __assign({
          className: "broadside-tool__item-title"
        }, {
          children: isInCms ? isChinese ? "QQ客服" : "QQ" : ""
        }), void 0), _jsx("div", __assign({
          className: "broadside-tool__item-content"
        }, {
          children: _jsxs("div", __assign({
            className: "broadside-tool__qq-detail"
          }, {
            children: [_jsx("h5", __assign({
              className: "broadside-tool__qq-title"
            }, {
              children: isChinese ? "QQ客服" : "QQ"
            }), void 0), this.state.QQ.map(function (item, index) {
              return _jsx("div", {
                className: "broadside-tool__qq-text",
                dangerouslySetInnerHTML: {
                  __html: qqKeFuHref(item.Value, item.Name)
                }
              }, index);
            }), _jsx("span", {
              className: "broadside-tool__arrow broadside-tool__qq-arrow"
            }, void 0)]
          }), void 0)
        }), void 0)]
      }), void 0), isInCms && _jsxs("li", __assign({
        className: "broadside-tool__item broadside-tool__tel--cms"
      }, {
        children: [_jsx("span", {
          className: "icon broadside-tool__tel-icon"
        }, void 0), _jsx("span", __assign({
          className: "broadside-tool__item-title"
        }, {
          children: isChinese ? "联系电话" : "Tel"
        }), void 0), _jsx("div", __assign({
          className: "broadside-tool__item-content"
        }, {
          children: _jsxs("div", __assign({
            className: "broadside-tool__tel-detail"
          }, {
            children: [_jsx("h5", __assign({
              className: "broadside-tool__tel-numbers-title"
            }, {
              children: isChinese ? "联系客服" : "Hotline"
            }), void 0), _jsx("div", {
              className: "broadside-tool__tel-numbers"
            }, void 0), _jsx("span", {
              className: "broadside-tool__arrow broadside-tool__tel-arrow"
            }, void 0)]
          }), void 0)
        }), void 0)]
      }), void 0), !isInCms && _jsxs("li", __assign({
        className: "broadside-tool__item broadside-tool__chat"
      }, {
        children: [_jsx("span", {
          className: "icon broadside-tool__chat-icon"
        }, void 0), _jsx(BroadsideNotification, {
          totalUnreadMessageCount: this.state.totalUnreadMessageCount
        }, void 0), _jsx("div", __assign({
          className: "broadside-tool__item-content"
        }, {
          children: _jsx(BroadsideContactList, {
            contacts: this.state.contacts,
            onClickContact: this.handleOpenContact
          }, void 0)
        }), void 0)]
      }), void 0), isInCms && _jsxs("li", __assign({
        className: "broadside-tool__item broadside-tool__chat--cms"
      }, {
        children: [_jsx("span", {
          className: "icon broadside-tool__chat-icon"
        }, void 0), _jsxs("span", __assign({
          className: "broadside-tool__item-title"
        }, {
          children: [isChinese ? "在线咨询" : "Chat", " "]
        }), void 0), _jsx(BroadsideNotification, {
          totalUnreadMessageCount: this.state.totalUnreadMessageCount
        }, void 0), _jsx("div", __assign({
          className: "broadside-tool__item-content"
        }, {
          children: _jsx(BroadsideContactListCms, {
            contacts: this.state.contacts,
            lang: langSetting,
            onClickContact: this.handleOpenContact,
            onClickInactiveCustomerService: this.handleOpenCustomerService
          }, void 0)
        }), void 0)]
      }), void 0), !isInCms && _jsxs("li", __assign({
        className: "broadside-tool__item broadside-tool__qrcode"
      }, {
        children: [_jsx("span", {
          className: "icon broadside-tool__qrcode-icon"
        }, void 0), _jsx("div", __assign({
          className: "broadside-tool__item-content"
        }, {
          children: _jsxs("div", __assign({
            className: "broadside-tool__qrcode-detail"
          }, {
            children: [_jsx("h6", __assign({
              className: "broadside-tool__qrcode-title"
            }, {
              children: "\u98DE\u9E3D\u8054\u52A8\u4E0B\u8F7D"
            }), void 0), _jsx("div", __assign({
              className: "broadside-tool__qrcode"
            }, {
              children: _jsx("img", {
                src: QRCODE_PATH,
                alt: "\u70FD\u706B\u53F0\u4E8C\u7EF4\u7801"
              }, void 0)
            }), void 0), _jsx("div", __assign({
              className: "broadside-tool__qrcode-text"
            }, {
              children: "\u626B\u7801\u4E0B\u8F7D\u98DE\u9E3D\u8054\u52A8App"
            }), void 0), _jsx("div", __assign({
              className: "broadside-tool__qrcode-note"
            }, {
              children: "\u53D1\u6398\u5546\u673A\u5C31\u4E0A\u98DE\u9E3D\u8054\u52A8"
            }), void 0), _jsx("span", {
              className: "broadside-tool__arrow broadside-tool__qrcode-arrow"
            }, void 0)]
          }), void 0)
        }), void 0)]
      }), void 0), isInCms && _jsxs("li", __assign({
        className: "broadside-tool__item broadside-tool__qrcode--cms"
      }, {
        children: [_jsx("span", {
          className: "icon broadside-tool__qrcode-icon"
        }, void 0), _jsxs("span", __assign({
          className: "broadside-tool__item-title"
        }, {
          children: [isChinese ? "手机预览" : "To shop", " "]
        }), void 0), _jsx("div", __assign({
          className: "broadside-tool__item-content"
        }, {
          children: _jsxs("div", __assign({
            className: "broadside-tool__qrcode-detail broadside-tool__qrcode-detail--cms"
          }, {
            children: [_jsxs("h6", __assign({
              className: "broadside-tool__qrcode-title"
            }, {
              children: [" ", isChinese ? "飞鸽联动扫码" : "Scan code"]
            }), void 0), _jsx("div", __assign({
              className: "broadside-tool__qrcode"
            }, {
              children: _jsx("span", {
                className: "broadside-tool__qrcode-img cms-qrcode--aside",
                title: isChinese ? "手机商铺二维码" : "Mobile shop QR code"
              }, void 0)
            }), void 0), _jsx("div", __assign({
              className: "broadside-tool__qrcode-text"
            }, {
              children: isChinese ? "使用飞鸽联动App扫码" : "Scan with App"
            }), void 0), _jsxs("div", __assign({
              className: "broadside-tool__qrcode-note"
            }, {
              children: [" ", isChinese ? "扫码查看手机商铺" : "Scan QR code for mobile shop"]
            }), void 0), _jsx("span", {
              className: "broadside-tool__arrow broadside-tool__qrcode-arrow"
            }, void 0)]
          }), void 0)
        }), void 0)]
      }), void 0), !isInCms && _jsx("li", __assign({
        className: "broadside-tool__item broadside-tool__feedback js-start-feedback",
        title: "\u610F\u89C1\u53CD\u9988"
      }, {
        children: _jsx("span", {
          className: "icon broadside-tool__feedback-icon"
        }, void 0)
      }), void 0)]
    }), void 0);
  };

  return BroadsideTool;
}(React.Component);

export default BroadsideTool;